const people = [
    {
        'name':'Quyum Kehinde',
        'bd': 'September 18',
        'age': '17',
        'img': 'images/person-2.jpg'
    },
    {
        'name':'Tommy Jones',
        'bd': 'March 10',
        'age': '18',
        'img': 'images/person-1.jpg'
    },
    
    {
        'name':'Marcus Rashford',
        'bd': 'May 5',
        'age': '23',
        'img': 'images/person-3.jpg'
    },
    {
        'name':'Adesare Adegbagi',
        'bd': 'February 16',
        'age': '34',
        'img': 'images/person-4.jpg'
    },
    {
        'name':'Anthony Black',
        'bd': 'December 2',
        'age': '24',
        'img': 'images/person-5.jpg'
    }
]
export default people;